export const initPublicCopyText = (root = document) => {
  root.querySelectorAll('[data-copy-text]').forEach((button) => {
    if (button.dataset.copyTextInitialized === 'true') return;
    button.dataset.copyTextInitialized = 'true';
    let resetTimer;
    button.addEventListener('click', async () => {
      const label = button.querySelector('[data-copy-label]');
      try {
        await navigator.clipboard.writeText(button.dataset.copyText || '');
        if (label) label.textContent = 'Copied';
      } catch (_error) {
        if (label) label.textContent = 'Copy failed';
      }
      if (resetTimer) window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(() => {
        if (label) label.textContent = 'Copy';
        resetTimer = undefined;
      }, 1800);
    });
  });
};
